import { useEffect, useRef, useState } from "react";
import { useRouteNavigation } from "../../lib/common/routes";
import { TChatListRow } from "../../lib/types/chats";
import { RouteEnumType } from "../../lib/types/routes";
import { useServiceContext } from "../../contexts/service";

type TOneConversationMenuProps = {
    chatRowData: TChatListRow;
    onCloseMenu: () => void;
    // deleteCallback: (user_id: number) => void;
    conversationArchivedHandler: (conversation_id: number) => void;
    conversationUnArchivedHandler: (conversation_id: number) => void;
};

export const OneConversationSubMenu = ({
    chatRowData,
    onCloseMenu,
    conversationArchivedHandler,
    conversationUnArchivedHandler,
}: // deleteCallback,
TOneConversationMenuProps) => {
    const { navigateRouteClickHandler } = useRouteNavigation();
    const refDeleteConversationModal = useRef<HTMLDivElement>(null);
    const windowGlobal = window as any;
    const [showFirstModal, setShowFirstModal] = useState(false);

    const {
        chats: { sendToArchive },
    } = useServiceContext();

    let profileLink: RouteEnumType;
    if (chatRowData.user_type === "tech") {
        profileLink = "dentalTechInfo";
    } else if (chatRowData.user_type === "lab") {
        profileLink = "dentalLabInfo";
    }

    const sentToArchiveHandler = async (conversation_id: number) => {
        onCloseMenu();
        await sendToArchive(conversation_id, true);
        conversationArchivedHandler(conversation_id);
    };

    const sentToInboxHandler = async (conversation_id: number) => {
        onCloseMenu();
        await sendToArchive(conversation_id, false);
        conversationUnArchivedHandler(conversation_id);
    };

    const handleFirstModalClose = () => {
        if (!refDeleteConversationModal.current) {
            setTimeout(() => {
                handleFirstModalClose();
            }, 100);
            return;
        }
        if (windowGlobal.wwg_refDeleteConversationModal) {
            //TODO: change to window.bootstrap.Modal.getInstance(refDeleteConversationModal.current)?.hide(); when we update to bootstrap 5.2
            windowGlobal.wwg_refDeleteConversationModal.hide();
        }
        setShowFirstModal(false);
    };

    useEffect(() => {
        return () => {
            if (windowGlobal.wwg_refDeleteConversationModal) {
                windowGlobal.wwg_refDeleteConversationModal.hide();
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (
        <>
            <div className="dropdown-menu show actionsMenu">
                <button
                    className="dropdown-item"
                    onClick={(e) => {
                        e.stopPropagation();
                        onCloseMenu();
                        navigateRouteClickHandler(profileLink, e, chatRowData.chat_with_user_id.toString(), true);
                    }}
                >
                    <i className="fa-solid fa-user me-2 fa-xs"></i>
                    <small>View Profile</small>
                </button>
                {!chatRowData.is_archived ? (
                    <button
                        className="dropdown-item"
                        onClick={(e) => {
                            e.stopPropagation();
                            sentToArchiveHandler(chatRowData.conversation_id);
                        }}
                    >
                        <i className="fa-solid fa-box-archive me-2 fa-xs"></i>
                        <small>Archive</small>
                    </button>
                ) : (
                    <button
                        className="dropdown-item"
                        onClick={(e) => {
                            e.stopPropagation();
                            sentToInboxHandler(chatRowData.conversation_id);
                        }}
                    >
                        <i className="fa-solid fa-box-archive me-2 fa-xs"></i>
                        <small>Reset</small>
                    </button>
                )}

                {/* <button
                    className="dropdown-item btn text-danger"
                    onClick={handleFirstModalShow}
                    type="button"
                    // disabled
                >
                    <i className="fa-regular fa-trash-can me-2 fa-xs"></i>
                    <small>Delete</small>
                </button> */}
            </div>

            {/* Delete Conversation Modal */}
            {showFirstModal && (
                <div className="modal fade" tabIndex={-1} ref={refDeleteConversationModal} aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content bg-light">
                            <div className="modal-header">
                                <h5 className="modal-title fw-bold text-danger">
                                    <i className="fa-regular fa-trash-can me-2 fa-xs"></i>
                                    <small>Delete conversation from your inbox</small>
                                </h5>
                                <button type="button" className="btn-close" aria-label="Close" onClick={handleFirstModalClose}></button>
                            </div>
                            <div className="modal-body">
                                <p>
                                    {" "}
                                    <strong>⚠️ This conversation will be deleted permanently.</strong>
                                </p>
                            </div>
                            <div className="modal-footer">
                                <button className="btn btn-outline-primary" onClick={handleFirstModalClose}>
                                    Cancel
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-danger"
                                    onClick={() => {
                                        console.log("click yes proceed");
                                    }}
                                >
                                    Delete
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};
